/**
 * WooCommerce account / account-related functions
 *
 * @since 1.0.0
 * @package grocery
 */

var $ = jQuery;

var GroceryAccount = {

	/**
	 * Spin up stuff
	 *
	 * @since 1.0.0
	 */
	init : function() {

		// sanity check
		if ( ! $( 'body' ).hasClass( 'woocommerce-edit-account' ) ) {
			return;
		}

		GroceryAccount.addFormEnctype();
	},


	/**
	 * Add "multipart" form enctype to allow file uploads
	 *
	 * @since 1.0.0
	 */
	addFormEnctype : function() {
		$( 'form.edit-account' ).attr( 'enctype', 'multipart/form-data' );
	}
};

// spin up the deal
$( document ).ready( GroceryAccount.init );
